<div class="page-container" animate.enter="route-slide-in-right" animate.leave="route-slide-out-right">
  <app-card>
    <app-card-header>
      <app-card-title>
        <div class="flex flex-align-center gap-sm">
          <app-back-button [ariaLabel]="'settings.back' | translate" />
          <span>{{ 'settings.workContexts.title' | translate }}</span>
        </div>
      </app-card-title>
    </app-card-header>
    <app-card-content>
      @if (contexts().length === 0) {
        <p class="empty-state" data-testid="work-contexts-empty">{{ 'settings.workContexts.empty' | translate }}</p>
      } @else {
        <ul class="context-list" data-testid="work-context-list">
          @for (context of contexts(); track context.id) {
            <li class="context-row flex flex-align-center flex-justify-space-between gap-sm" [attr.data-testid]="'work-context-row-' + context.id">
              <div class="flex flex-column">
                <span class="context-name">{{ context.name }}</span>
                @if (tagLabelsFor(context); as tagLabels) {
                  <span class="context-tags">{{ tagLabels }}</span>
                }
                @if (!context.is_active) {
                  <span class="context-inactive-badge">{{ 'settings.workContexts.inactive' | translate }}</span>
                }
              </div>
              <div class="flex gap-xs">
                <app-button variant="text" (click)="toggleActive(context)" [attr.data-testid]="'toggle-work-context-' + context.id">
                  {{ (context.is_active ? 'settings.workContexts.deactivate' : 'settings.workContexts.activate') | translate }}
                </app-button>
                <app-button variant="text" (click)="openEdit(context)" [attr.data-testid]="'edit-work-context-' + context.id">
                  <app-icon name="pencil" [size]="14" />
                </app-button>
              </div>
            </li>
          }
        </ul>
      }
    </app-card-content>
    <app-card-actions>
      <app-button variant="filled" (click)="openCreate()" data-testid="new-work-context-button">
        <app-icon name="plus" />
        {{ 'settings.workContexts.new' | translate }}
      </app-button>
    </app-card-actions>
  </app-card>
</div>

@if (showEditor()) {
  <app-modal-dialog (backdropClick)="closeEditor()">
    <div header>
      <div class="heading-md">{{ (editing() ? 'settings.workContexts.editTitle' : 'settings.workContexts.newTitle') | translate }}</div>
    </div>
    <div content>
      @if (error()) {
        <div class="error-container p-md" data-testid="work-context-form-error">{{ error() }}</div>
      }
      <form [formGroup]="form">
        <formly-form [form]="form" [fields]="fields" [model]="model" />
      </form>
    </div>
    <div footer>
      <app-button variant="text" (click)="closeEditor()" data-testid="cancel-work-context-button">
        {{ 'settings.workContexts.cancel' | translate }}
      </app-button>
      <app-button variant="filled" color="primary" [disabled]="saving()" (click)="save()" data-testid="save-work-context-button">
        {{ 'settings.workContexts.save' | translate }}
      </app-button>
    </div>
  </app-modal-dialog>
}
